import { AppText } from "@/components/Text/AppText";

interface LoadingStateProps {
    message?: string;
    className?: string;
}

export const LoadingState = ({
    message = "Loading scans...",
    className = "flex items-center justify-center py-8",
}: LoadingStateProps) => {
    return (
        <div className={className}>
            <AppText
                variant="regular"
                className="text-gray-500"
            >
                {message}
            </AppText>
        </div>
    );
};
